import { useTranslation } from "react-i18next";

/**
 * Final CTA. Heavy display headline, two CTAs. Dark theme gets a
 * subtle radial bloom behind the headline.
 */
export function FinalCta() {
  const { t } = useTranslation();
  return (
    <section className="relative border-b border-[color:var(--color-app-edge)] overflow-hidden">
      <div className="absolute inset-0 bg-fieldgrid opacity-50 pointer-events-none" />
      <div
        className="absolute inset-0 pointer-events-none opacity-0 dark:opacity-100 transition-opacity"
        style={{
          background:
            "radial-gradient(60% 60% at 50% 100%, rgba(168, 200, 120, 0.18), transparent 70%)",
        }}
      />
      <div className="relative mx-auto max-w-[1320px] px-6 lg:px-10 py-28 md:py-36 text-center">
        <div className="label-mono mb-6">
          <span className="bracket">{t("cta.endLabel")}</span>
        </div>
        <h2 className="text-display text-6xl md:text-7xl lg:text-8xl mx-auto max-w-4xl leading-[0.95]">
          {t("cta.headline.before")}{" "}
          <span className="text-accent text-accent-amber">{t("cta.headline.accent")}</span>{" "}
          {t("cta.headline.after")}
        </h2>
        <p className="mt-8 max-w-xl mx-auto text-[color:var(--color-app-text)]/75 text-lg leading-relaxed">
          {t("cta.subhead")}
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <a
            href="/app"
            className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-medium bg-[color:var(--color-forest)] text-[color:var(--color-paper)] dark:bg-[color:var(--color-meadow)] dark:text-[color:var(--color-ink)] hover:opacity-90 transition-opacity"
          >
            {t("common.openDashboard")}
            <span aria-hidden>→</span>
          </a>
          <a
            href="mailto:hi@ultrascan.ai"
            className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-medium border border-[color:var(--color-app-edge-2)] hover:bg-[color:var(--color-app-card)] transition-colors"
          >
            {t("common.talkToUs")}
          </a>
        </div>
      </div>
    </section>
  );
}
